export default __webpack_public_path__ + "static/media/hero-laptop.a91ab248.png";